import { Button } from 'antd';

/**
 * Выход из набора отборов на десктопе (ADR 0139).
 *
 * До памяти отборов кнопка была не нужна: набор жил один сеанс и разбирался тем же движением,
 * которым собран, — крестиком в каждом поле. Сохранённый набор человек застаёт готовым, в том
 * числе чужой рукой выставленный на общем компьютере, и «покажи всё» должно стоить одного
 * нажатия, а не шести.
 *
 * Показывается, только когда есть что снимать: кнопка «Сбросить» над пустым отбором обещает
 * действие, которого не произойдёт. На телефоне то же движение живёт в шите фильтров
 * (`FilterSheet`) — второй кнопки там не нужно.
 */
export function FilterReset({ active, onClick }: { active: boolean; onClick: () => void }) {
  if (!active) return null;
  return (
    <Button type="link" onClick={onClick}>
      Сбросить
    </Button>
  );
}
